import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiWithoutCamelization } from "../../../../../../api";
import { siteWizardQuery } from "../../../../../../hooks/useSiteWizard";
import type { components } from "../../../../../../types/api.types";
import urls from "../../../../../../urls";
import { vollmachtVermarkterFilesQueries } from "./useVollmachtVermarkterFiles";

type VermarkterVollmachtConfirmationSuccess =
  components["schemas"]["VermarkterVollmachtConfirmationSuccess"];

interface ConfirmVermarkterVollmachtParams {
  todoFileId: number;
  userConfirmedExtractedData: boolean;
}

function useConfirmVollmachtVermarkter(siteId: number) {
  const queryClient = useQueryClient();

  const confirmVollmachtVermarkterMutation = useMutation({
    mutationFn: ({
      todoFileId,
      userConfirmedExtractedData
    }: ConfirmVermarkterVollmachtParams) =>
      apiWithoutCamelization.post<VermarkterVollmachtConfirmationSuccess>(
        urls.apiWithoutCamelization.confirmVermarkterVollmachtFile(),
        {
          todo_file_id: todoFileId,
          user_confirmed_extracted_data: userConfirmedExtractedData
        }
      ),
    onSettled() {
      queryClient.invalidateQueries(
        vollmachtVermarkterFilesQueries.bySiteId(siteId)
      );
      queryClient.invalidateQueries(siteWizardQuery(siteId));
    }
  });

  return { confirmVollmachtVermarkterMutation };
}

export { useConfirmVollmachtVermarkter };
